import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, MenuController, ModalController } from 'ionic-angular';
import { Http } from '@angular/http';

import "rxjs/add/operator/map";

import unraw from "unraw";

import { ImcpaAppProvider } from '../../../providers/imcpaApp/imcpaApp';
import { MysqlService } from '../../../services/mysql.service';

import { FarmListPage } from '../farmList/farmList';
// import { FarmDetailPage } from '../farmDetail/farmDetail';

// import { CowListPage } from '../cowList/cowList';
import { CowDashboardPage } from '../../cows/cowDashboard/cowDashboard';
import { UpdateCowPage } from '../../cows/updateCow/updateCow';
// import { AddCowPage } from '../addCow/addCow';
// import { CapturePhotoPage } from '../capturePhoto/capturePhoto';

// import { VetListPage } from '../vetList/vetList';
// import { VetDetailPage } from '../vetDetail/vetDetail';
// import { AddVetPage } from '../addVet/addVet';

import { AddFarmPage } from '../addFarm/addFarm';
// import { AddAssetPage } from '../addAsset/addAsset';
// import { AddFeedPage } from '../addFeed/addFeed';
// import { FeedModalPage } from '../addFeed/feedModal/feedModal';
// import { AddFinancePage } from '../addFinance/addFinance';
// import { AddFundingPage } from '../addFunding/addFunding';
// import { AddMedicalStockPage } from '../addMedicalStock/addMedicalStock';
// import { AddStoreItemPage } from '../addStoreItem/addStoreItem';
// import { AddTaskPage } from '../addTask/addTask';

// declare var google;
let map: any;

interface Track{
  region: string;
  team: string;
  incident_date: string;
}

@Component({
  selector: 'page-farmDashboard',
  templateUrl: 'farmDashboard.html',
  // styleUrls: [ 'farmDashboard.scss', '../../theme/variables.scss' ]
})
export class FarmDashboardPage {
  

  @ViewChild('map') mapElement: ElementRef;
  zoom: number = 10;
  
  // initial center position for the map
  // lat: number = -28.356138;
  // lng: number = 153.31907;

  tracker: string = "Infrigement";

  public myreturnvalue;
  public loading;

  public goshala: any = {};
  public cows = [];
  public vets: {};
  public medicals: {};
  public medicalTransactions: {};
  public medicalStockSummarys: {};
  public tasks: {};
  public assets: {};
  public finances: {};
  public fundings: {};
  public storeItems: {};
  public feedStocks: any;
  public feedTransactions = [];
  public cowPens = [];
  public count = 0;
  public currentDate = new Date();
  // public date = this.currentDate.getFullYear()+'-'+(this.currentDate.getMonth()+1)+'-'+this.currentDate.getDate(); 
  // public dd = String(this.currentDate.getDate()).padStart(2, '0');
  // public mm = String(this.currentDate.getMonth() + 1).padStart(2, '0'); //January is 0!
  public yyyy = this.currentDate.getFullYear();
  // public date = this.yyyy + '-' + this.mm + '-' + this.dd;
  public pen = [];
  public changeView = "list";
  progress = 50;
  
  farmDashboard: string = "profile";
  medicalDashboard: string = "medicalHistory";
  financeDashboard: string = "incomeExpenditure";
  profileSubSegment: string = "farm";

  constructor(public navCtrl: NavController, public navParams: NavParams, public myApp: ImcpaAppProvider, public http: Http, private dbService: MysqlService, public loadingCtrl: LoadingController, public menu: MenuController, public modalCtrl: ModalController) {

    this.goshala = this.navParams.get("goshala");

    if(this.goshala.farmHistory !== null){
      this.goshala.farmHistory = unraw(this.goshala.farmHistory)
    }
    
    console.log("The Goshala Id is: " + this.goshala.id);

    if(this.navParams.get("farmDashboard") != undefined){
      this.farmDashboard = this.navParams.get("farmDashboard");
      if(this.navParams.get("farmDashboard") === 'feed'){
      this.getFeedStocks();
      }
      if(this.navParams.get("farmDashboard") === 'cows'){
      this.getCowPens();
      }
    }
    if(this.navParams.get("profileSubSegment") != undefined){

      this.profileSubSegment = this.navParams.get("profileSubSegment");
    }

    if(this.navParams.get("medicalDashboard") != undefined){
      this.medicalDashboard = this.navParams.get("medicalDashboard");
      if(this.navParams.get("medicalDashboard") === 'medicalHistory'){
      this.getMedicalReports();
      }
      if(this.navParams.get("medicalDashboard") === 'medicalStock'){
      this.getMedicalStockSummary();
      }
      if(this.navParams.get("medicalDashboard") === 'vets'){
      this.getVets();
      }
    }
    
    // this.getMedicalReports()
    // this.getMedicalTransactions()
    // this.getMedicalStockSummary();
    // this.getVets()
    // this.getCowPens();
    // this.vets = this.myApp.getVets();
    // this.medicals = this.myApp.getMedicals();
    // this.medicalStocks = this.myApp.getMedicalStocks();
    this.tasks = this.myApp.getTasks();
    this.assets = this.myApp.getAssets();
    this.finances = this.myApp.getFinances();
    this.fundings = this.myApp.getFundings();
    this.storeItems = this.myApp.getStoreItems();
    // this.feeds = this.myApp.getFeeds();
    // this.getFeeds();
    console.log(this.goshala.gpsLat);
    console.log(this.goshala.gpsLong);
    console.log("The Cows:" + this.cows);
    // console.log(this.date);
    console.log(this.cowPens)
  }

  ionViewDidEnter() {

    // Use the id to enable/disable the menus
    this.menu.enable(false, 'menu1');
    this.menu.enable(true, 'menu2');
  }

  searchCows(ev: any){
    console.log(ev.target);
    const val = ev.target.value;
    this.presentLoading();
    this.getCowsSearched(val);  
  }

  getCowsSearched(val){
    this.dbService.fetchDataV2("SELECT * FROM cows c where (goshala_id in (0, " + this.goshala.id + ") and pen = " + this.pen + ") and (name LIKE '%" + val + "%' OR gender LIKE '%" + val + "%' OR type LIKE '%" + val + "%' OR tattooNumber LIKE '%" + val + "%') order by c.name")
      .map(res => res.json())
      .subscribe(res => {
          this.loading.dismiss();
        this.cows=res.data;
        console.log(this.cows);
        // this.getGoshalaSearched(val)
        }, error => {
        alert("FAILED, to fetch from php : "+ error);
        this.myreturnvalue = "Error : " + error;
        console.log(this.myreturnvalue)
        this.loading.dismiss();
      });
    }

    getCowPens(){
    this.presentLoading();
    // console.log("Goshala id is: " + goshalaid);
    this.dbService.fetchDataV2('select pen from cows where goshala_id = ' + this.goshala.id + ' group by pen order by pen asc')
    // SELECT pen FROM cows WHERE goshala_id IN (4,0) GROUP BY pen ORDER BY pen ASC
      .map(res => res.json())
      .subscribe(res => {
          // this.loading.dismiss();
        this.cowPens=res.data;
        if(this.cowPens.length != 0){
          this.pen = this.cowPens[0].pen;
          console.log(this.cowPens);
          this.getCows(this.pen);
        } else {
          let promptCows = "No Cows Found!"
          this.loading.dismiss();
        }

        }, error => {
        alert("FAILED, to fetch from php : "+ error);
        this.myreturnvalue = "Error : " + error;
        console.log(this.myreturnvalue)
        this.loading.dismiss();
    });
  }

  getCows(pen){
    // console.log("Goshala id is: " + goshalaid);
    this.dbService.fetchDataV2('select * from cows where goshala_id =' + this.goshala.id + ' and pen=' + this.pen)
      .map(res => res.json())
      .subscribe(res => {
          this.loading.dismiss();
        this.cows=res.data;
        }, error => {
        alert("FAILED, to fetch from php : "+ error);
        this.myreturnvalue = "Error : " + error;
        console.log(this.myreturnvalue)
        this.loading.dismiss();
    });
  }

  getCowsBasedOnPen(pen){
    this.getCows(pen);
  }

  farmAuthorization(){
    if(this.myApp.access.role === 'Admin' || this.myApp.access.goshalaId === this.goshala.id || this.myApp.access.role === 'Continental Representative'){
      return true;
    } else {
      return false;
    }
  }


  loadSegmentItems(segmentTab){
    if(segmentTab === 'feed'){
      this.getFeedStocks()
    }
    if(segmentTab === 'cows'){
      this.getCowPens()
      console.log("The Cows:" + this.cows);
    }
    if(segmentTab === 'medicalHistory'){
      this.getMedicalReports();
    }
    if(segmentTab === 'medicalStock'){
      this.getMedicalStockSummary();
    }
    if(segmentTab === 'vets'){
      this.getVets()
    }
    
  }

  getFeedStocks(){
    this.presentLoading();
    // console.log("Goshala id is: " + goshalaid);
    this.dbService.fetchDataV2('select * from feedstock where goshala_id = ' + this.goshala.id)
    .map(res => res.json())
    .subscribe(res => {
      this.feedStocks = res.data; 
      this.getFeedTransactions()
      console.log("Jason data: " + res.data);
      // console.log("Cow Array : " + this.feeds);
     }, (err) => {
       this.loading.dismiss();
       alert("Failed to Load Json data" + err)
     });
  }

  goToFeedModal(feed){
    // const modal = this.modalCtrl.create(FeedModalPage, {goshala: this.goshala, feed: feed, actionType: "update"});
    // modal.present();
  }

  getFeedTransactions(){
    // console.log("Goshala id is: " + goshalaid);
    this.dbService.fetchDataV2('select * from feedTransactions where goshala_id = ' + this.goshala.id)
    .map(res => res.json())
    .subscribe(res => {
      this.feedTransactions = res.data; 
      console.log("Jason data: " + res.data);
      // console.log("Cow Array : " + this.feeds);
      this.loading.dismiss();
     }, (err) => {
       alert("Failed to Load Json data" + err)
       this.loading.dismiss();
     });
  }

  getMedicalStockSummary(){
    this.presentLoading()
    // console.log("Goshala id is: " + goshalaid);
    this.dbService.fetchDataV2('select * from medicalstock where goshala_id = ' + this.goshala.id)
      .map(res => res.json())
      .subscribe(res => {
          // this.loading.dismiss();
        this.medicalStockSummarys = res.data;
        this.getMedicalTransactions();
        }, error => {
        alert("FAILED, to fetch from php : "+ error);
        this.myreturnvalue = "Error : " + error;
        console.log(this.myreturnvalue)
        this.loading.dismiss();
    });
  }

  getMedicalTransactions(){
    // console.log("Goshala id is: " + goshalaid);
    this.dbService.fetchDataV2('select * from medicaltransactions where goshala_id = ' + this.goshala.id)
      .map(res => res.json())
      .subscribe(res => {
          this.loading.dismiss();
        this.medicalTransactions = res.data;
        }, error => {
        alert("FAILED, to fetch from php : "+ error);
        this.myreturnvalue = "Error : " + error;
        console.log(this.myreturnvalue)
        this.loading.dismiss();
    });
  }

  getMedicalReports(){
    this.presentLoading()
    // console.log("Goshala id is: " + goshalaid);
    this.dbService.fetchDataV2('select * from medicalreports where goshala_id = ' + this.goshala.id)
      .map(res => res.json())
      .subscribe(res => {
          this.loading.dismiss();
        this.medicals=res.data;
        }, error => {
        alert("FAILED, to fetch from php : "+ error);
        this.myreturnvalue = "Error : " + error;
        console.log(this.myreturnvalue)
        this.loading.dismiss();
    });
  }

    getVets(){
    this.presentLoading()
    // console.log("Goshala id is: " + goshalaid);
    this.dbService.fetchDataV2('select * from vets where goshalaId = ' + this.goshala.id)
      .map(res => res.json())
      .subscribe(res => {
          this.loading.dismiss();
        this.vets=res.data;
        }, error => {
        alert("FAILED, to fetch from php : "+ error);
        this.myreturnvalue = "Error : " + error;
        console.log(this.myreturnvalue)
        this.loading.dismiss();
    });
  }

  changeCowToImageView(){
    this.changeView = "image";
    console.log(this.changeView);
  }

  changeCowToListView(){
    this.changeView = "list";
    console.log(this.changeView);
  }

  async presentLoading() {
  this.loading = await this.loadingCtrl.create({
    content: 'Loading Data, please wait..',
  });
  return await this.loading.present();  
}

  goToAddFarmPage(goshala, segmentTab){
    this.navCtrl.push(AddFarmPage, {
      goshala: goshala, type: "Update Farm", segmentTab: segmentTab
    });
  }

  goToFarmDetailPage(goshala){
    // this.navCtrl.push(FarmDetailPage, {
    //   goshala: goshala
    // });
  }

  goToCowListPage(goshala) {
    // this.navCtrl.push(CowListPage, {
    //   goshala: goshala
    // });
  }

  goToVetListPage(goshala) {
    // this.navCtrl.push(VetListPage, {
    //   goshala: goshala
    // });
  }

  goToAddCowPage(goshala){
    this.navCtrl.push(UpdateCowPage, {
      goshala: goshala, type: 'add'
    });
  }

  goToCowDashboardPage(cow) {
    this.navCtrl.push(CowDashboardPage, {
      cow: cow, goshala: this.goshala
    });
  }

  goToUpdateCowPage(cow) {
    // this.navCtrl.push(UpdateCowPage, {
    //   cow: cow, goshala: this.goshala
    // });
  }

  goToCapturePhotoPage(cow) {
    // this.navCtrl.push(CapturePhotoPage, {
    //   cow: cow, goshala: this.goshala
    // });
  }

  goToAddVetPage(vet, actionType){
    // this.navCtrl.push(AddVetPage, {
    //    vet: vet, goshala: this.goshala, actionType: actionType
    // });
  }

  goToVetDetailPage(vet) {
    // this.navCtrl.push(VetDetailPage, {
    //   vet: vet, goshala: this.goshala
    // });
  }

  goToAddAssetPage(){
    // this.navCtrl.push(AddAssetPage, {
    //   goshala: this.goshala
    // });
  }

  goToAddFeedPage(){
    // this.navCtrl.push(AddFeedPage, {
    //   goshala: this.goshala
    // });
  }

  goToAddFinancePage(){
    // this.navCtrl.push(AddFinancePage, {
    //   goshala: this.goshala
    // });
  }

  goToAddFundingPage(){
    // this.navCtrl.push(AddFundingPage, {
    //   goshala: this.goshala
    // });
  }

    goToAddMedicalStockPage(){
    // this.navCtrl.push(AddMedicalStockPage, {
    //   goshala: this.goshala
    // });
  }

    goToAddStoreItemPage(){
    // this.navCtrl.push(AddStoreItemPage, {
    //   goshala: this.goshala
    // });
  }

  goToAddTaskPage(){
    // this.navCtrl.push(AddTaskPage, {
    //   goshala: this.goshala
    // });
  }

  goToMedicalSegment(){
    this.farmDashboard = "medical";
  }

  goToFeedSegment() {
    this.farmDashboard = "feed";
  }

  goToProfileSegment() {
    this.farmDashboard = "profile";
  }

  goToStoreSegment() {
    this.farmDashboard = "store";
  }

  goToCowSegment() {
    this.farmDashboard = "cows";
  }

  goToMaintenanceSegment() {
    this.farmDashboard = "maintenance";
  }

  goToAssetSegment() {
    this.farmDashboard = "assets";
  }

  goToFinanceSegment() {
    this.farmDashboard = "finance";
  }

ionViewDidLoad() {}
// clickedMarker(label: string, index: number) {
//     console.log(`clicked the marker: ${label || index}`)
//   }
  
  // mapClicked($event: MouseEvent) {
  //   this.markers.push({
  //     lat: $event.coords.lat,
  //     lng: $event.coords.lng,
  //     draggable: true
  //   });
  // }
  
  // markerDragEnd(m: marker, $event: MouseEvent) {
  //   // console.log('dragEnd', m, $event);
  // }
  
//   markers: marker[] = [
// 	  {
// 		  lat: -28.356138,
// 		  lng: 153.31907,
// 		  label: 'New Govardhan',
// 		  draggable: true
// 	  }
//   ]
}




// WEBPACK FOOTER //
// ./src/pages/farms/farmDashboard/farmDashboard.ts